import styled from 'styled-components'

import ResourceCounterList from './ResourceCounterList'
import MenuButton from './MenuButton'

export const SpacedRow = styled.div`
    display: flex;
    justify-content: space-between;
`

const StyledRow = styled(SpacedRow)`
    align-self: stretch;
    height: 24px;
    padding: 8px;

    background: lightgrey;
    border: 2px solid darkgrey;
`

function StatusBar() {
    return (
        <StyledRow>
            <ResourceCounterList />
        </StyledRow>
    )
}

export default StatusBar